module.exports = __webpack_public_path__ + "static/img/login-bg-xf.53459f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-bg-xf.png
// module id = Tr/v
// module chunks = 1